module.exports = "<span>\n  {{'PaymentForm.PaymentLimitReached'|translate}}\n</span>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/balance-over-limit/balance-over-limit.component.html
// module id = ../../../../../src/app/components/payment/balance-over-limit/balance-over-limit.component.html
// module chunks = main